<ng-container *ngrxLet="{ selectedLanguageDefinition: selectedLanguageDefinition$, isTriggerIconHidden: isTriggerIconHidden$ } as vm">
    <button
        [matMenuTriggerFor]="languageSelectMenu"
        type="button"
        class="trigger-button"
        *ngIf="vm.selectedLanguageDefinition"
        #trigger="matMenuTrigger"
    >
        <dtm-ui-country-flag-display [country]="vm.selectedLanguageDefinition.flagName" />
        {{ vm.selectedLanguageDefinition.alpha2Code | uppercase }}
        <dtm-ui-icon *ngIf="!vm.isTriggerIconHidden" [name]="trigger.menuOpen ? 'arrow-up-single' : 'arrow-down'" />
    </button>
    <mat-menu #languageSelectMenu="matMenu" xPosition="before">
        <button
            *ngFor="let entry of languageDefinitions$ | ngrxPush"
            mat-menu-item
            type="button"
            [class.selected-option]="entry.alpha2Code === vm.selectedLanguageDefinition?.alpha2Code"
            (click)="changeLanguage(entry.alpha2Code)"
        >
            <dtm-ui-country-flag-display [country]="entry.flagName" />
            {{ entry.displayName }}
        </button>
    </mat-menu>
</ng-container>
